import React from "react"
import { Col, Row } from "react-bootstrap"
import { CardOffer } from "./card-offer.component"

export function CardOfferBar(props){
    const {navigate} = props;
    return (
        <Row className='pt-4'>
            {props.offers.map((offer, index) => (
                <Col
                    key={index} xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}
                >
                    <CardOffer data={offer} navigate={navigate} />
                </Col>
            ))}
        </Row>
    )
}